import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { PullTariffsModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/tariffs/pull-tariffs.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { usePullEmspBoTariffContext } from '../../emsp-bo-tariff.context';
import { EmspBoTariffPullCreateFormStep1Controller } from '../emsp-bo-tariff-pull-create-form-step-1/emsp-bo-tariff-pull-create-form-step-1.controller';

interface EmspBoTariffPullCreateFormControllerProps {
  onError: SubmitErrorHandler<PullTariffsModel>;
  onSubmit: SubmitHandlerWithDirtyFields<PullTariffsModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoTariffPullCreateFormController = (
  props: EmspBoTariffPullCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = usePullEmspBoTariffContext();

  return (
    <MultiStepFormProvider<PullTariffsModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['cpoId'],
          component: <EmspBoTariffPullCreateFormStep1Controller />,
        },
      ]}
    />
  );
};
